/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-kitchen': {
    width: 16,
    height: 16,
    viewBox: '0 0 300 300',
    data: '<path pid="0" d="M254 58a12 12 0 00-12-12h-64a12 12 0 00-12 12v44a12 12 0 003.08 8 12 12 0 00-3.08 8v124a12 12 0 0012 12h64a12 12 0 0012-12V118a12 12 0 00-3.08-8 12 12 0 003.08-8zm-80 0a4 4 0 014-4h64a4 4 0 014 4v44a4 4 0 01-4 4h-64a4 4 0 01-4-4zm72 184a4 4 0 01-4 4h-64a4 4 0 01-4-4V118a4 4 0 014-4h64a4 4 0 014 4zM142 156h-40v-14h8v-4h-8v-4a6 6 0 00-6-6H64a6 6 0 00-6 6v4h-8v4h8v14a12 12 0 00-12 12v74a12 12 0 0012 12h84a12 12 0 0012-12v-74a12 12 0 00-12-12zm-80-22a2 2 0 012-2h32a2 2 0 012 2v22H62zm84 108a4 4 0 01-4 4H58a4 4 0 01-4-4v-74a4 4 0 014-4h84a4 4 0 014 4z"/><path pid="1" d="M178 80h4v20h-4zM178 130h4v40h-4zM136 188H64a6 6 0 00-6 6v42a6 6 0 006 6h72a6 6 0 006-6v-42a6 6 0 00-6-6zm2 48a2 2 0 01-2 2H64a2 2 0 01-2-2v-42a2 2 0 012-2h72a2 2 0 012 2z"/>'
  }
})
